import * as React from "react"
import { Dispatch, SetStateAction } from "react"
import { PopupButton } from "react-calendly"

interface HourlyScheduleProps {
  hourlySelectedOption: { title: string } | undefined
  setHourlySelectedOption: Dispatch<
    SetStateAction<{ title: string } | undefined>
  >
  setBookSlotPopup: Dispatch<SetStateAction<boolean>>
}
export const HourlySchedule = ({
  hourlySelectedOption,
  setHourlySelectedOption,
  setBookSlotPopup,
}: HourlyScheduleProps) => {
  const data = [
    {
      title: "Project Based Pricing",
      options: [
        {
          title: "Hourly Price",
          subTitle: "(Starting From $30)",
        },
        {
          title: "Fix Price",
          subTitle: "(Starting From $2000)",
        },
        {
          title: "Hourly Price for a Full Project",
          subTitle: "",
        },
        {
          title: "Hourly Price for Senior Resource",
          subTitle: "",
        },
      ],
    },
  ]
  const [rootElement, setRootElement] = React.useState<HTMLElement | null>(null)

  React.useEffect(() => {
    if (typeof window !== "undefined") {
      const element = document.getElementById("___gatsby")
      setRootElement(element)
    }
  }, [])
  return (
    <div className="mt-10 pt-10 container mx-auto">
      <div className="flex gap-1 justify-center">
        <h2 className="text-black lg:text-3xl text-xl font-bold text-center">
          {data[0].title}
        </h2>
        <p className="pt-2 text-black"> (Optional)</p>
      </div>
      <p className="text-gray text-xs text-center">
        Let’s discuss in a meeting,{" "}
        {rootElement && (
          <PopupButton
            className="text-[#7B68EC] border-b border-[#7B68EC] text-sm font-bold"
            url="https://calendly.com/visualfolio-info/30min"
            rootElement={rootElement}
            text="Book a Slot"
          />
        )}
      </p>
      <div className="flex mx-3 justify-center">
        <form className="flex flex-wrap lg:gap-10 gap-3 items-center mt-10">
          {data[0].options.map((option, index) => (
            <div
              onClick={() =>
                setHourlySelectedOption(
                  hourlySelectedOption?.title === option.title
                    ? undefined
                    : option
                )
              }
              key={index}
              className="flex gap-2 items-center"
            >
              <div className="border border-[#7B68EC] rounded-full flex items-center p-1">
                <input
                  className="input-radio"
                  type="radio"
                  id={option.title}
                  value={option.title}
                  name="hourly"
                  checked={hourlySelectedOption?.title === option.title}
                  readOnly
                />
              </div>
              <div className="flex gap-1 items-center">
                <label className="text-black" htmlFor={option.title}>
                  {option.title}
                </label>
                <p className="text-[#7B68EC] text-xs">{option.subTitle}</p>
              </div>
            </div>
          ))}
        </form>
      </div>
    </div>
  )
}
